import { lazy } from "react";

const newsRoutes = [
    { path: '/', component: lazy(() => import('../../views/trang-tin/TrangChu')) },
]

export default newsRoutes
